// eslint-disable-next-line import/no-webpack-loader-syntax
require('expose-loader?BetslipKeypad!../../src/app/betslip_keypad');
